import React, { Component } from 'react';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy withRouter (baseline)
import { withRouter, Link } from 'react-router-dom';
// eslint-disable-next-line no-restricted-imports -- TODO: legacy connect (baseline)
import { connect } from 'react-redux';

import { apiBuilder } from 'utils/api/common-requests/common-requests';
import * as endpoints from 'utils/api/endpoints';
import { trackedEvents, trackEvent } from 'telemetry/app-analytics';
import {
    isBrandedByHockeyTech,
    isBrandedByMocap,
    isNahlPlayerAccount,
    isProspectMode,
    isSingleTeamView,
    userHavePlayerIdAndFeatureMask
} from 'selectors/user/user-features-selector';
import ThemeContainer from 'components/theme-container/theme-container';
import { LogoComponent } from 'components/logo/logo-component';
import { clientsAdminIndex } from 'constants/page-names';
import DeviceSelector from 'components/device-selector/device-selector';
import { isUserClient } from 'selectors/user/user-roles-selector';
import { isMobile as isMobileSelector } from 'redux/modules/device-type';
import { readCurrentUser } from 'redux/modules/user';
import { notificationTypes, notify } from 'redux/modules/notifications';

import TooltipAnchor from '../tooltip/anchor';

import ProductSelector from './components/product-selector';
import { LinksNav, Nav } from './components/secondary-navigation-bar';
import {
    clearStoredUserData,
    hasAuthKey,
    hasTemporaryKey,
    isSharedSession,
    joinByOriginKey
} from 'utils/api/auth-utils';
import ErrorBoundary from './private/error-boundary';
import NavBar from './private/components/nav-bar/nav-bar';
import {
    Brand,
    HeaderCenter,
    HeaderEnd,
    HeaderSearchSlot,
    HeaderStart
} from './private/components/nav-bar/nav-bar.styled';
import { BackToAdminLink } from './private/components/back-to-admin-link';
import AppLayout, { AppContent } from './private/layout';
import Language from './private/language';
import Profile from './private/components/profile';
import Footer from './private/footer';
import { logout } from './module.js';
import InfoWarning from './private/info-warning';
import EditEmailModal from './private/edit-email-modal';
import EditPasswordModal from './private/edit-password-modal';
import SupportRequest from './private/components/support-request';
import ClipServiceInformer from './private/components/clip-service-informer';
import NotificationsPanel from './private/notifications-panel';
import TopSearchPanel from './private/components/top-search-panel';
import ReleaseNote from './private/components/release-note/release-note';
import EditVideoPlayerModal from './private/edit-video-player-modal';
import SubNavBar from './private/components/sub-nav-bar';
import { NotificationBar } from './components/notification-banner';
import AppLauncher from './private/components/app-launcher';
import LauncherItemsSync from './private/components/app-launcher/components/launcher-items-sync';
import { isCenteredHeaderNavPath } from './private/components/app-launcher/nav-link-utils';

const warningForUser = false;

const MAX_WIDTH_PROSPECT = 900;

const mapStateToProps = state => ({
    statsFilter: state.statsFilter,
    activeUser: state.user,
    isFavoriteListNeedToFetch: state.favourites.isFavoriteListNeedToFetch,
    singleTeamView: isSingleTeamView(state),
    brandedByMocap: isBrandedByMocap(state),
    brandedByHockeyTech: isBrandedByHockeyTech(state),
    nahlPlayerAccount: isNahlPlayerAccount(state),
    prospectExchangeAccount: isProspectMode(state),
    isUserClient: isUserClient(state),
    isMobile: isMobileSelector(state),
    userHaveSomeFeatureAndPlayerId: userHavePlayerIdAndFeatureMask(state)
});

const mapDispatchToProps = {
    logout,
    readCurrentUser,
    notify
};

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy class component (baseline)
class App extends Component {
    state = {
        editEmailIsOpen: false,
        editableEmail: null,
        editPasswordIsOpen: false,
        editVideoPlayerIsOpen: false
    };

    logout() {
        trackEvent(trackedEvents.LOGOUT);

        if (isSharedSession()) {
            clearStoredUserData();
            window.location.assign('/');

            return;
        }

        apiBuilder()
            .post(endpoints.logout)
            .then(() => {
                clearStoredUserData();
                window.location.assign('/');
            })
            .catch(() => window.location.reload());
    }

    editEmail = email => {
        this.setState({ editEmailIsOpen: true, editableEmail: email });
    };

    onCancelEditEmail = () => {
        this.setState({ editEmailIsOpen: false });
    };

    editPassword = () => {
        this.setState({ editPasswordIsOpen: true });
    };

    onCancelEditPassword = () => {
        this.setState({ editPasswordIsOpen: false });
    };

    editVideoPlayer = () => {
        this.setState({ editVideoPlayerIsOpen: true });
    };

    onCancelEditVideoPlayer = () => {
        this.setState({ editVideoPlayerIsOpen: false });
    };

    backToAdmin() {
        apiBuilder()
            .post(endpoints.logout)
            .then(() => {
                joinByOriginKey();
                window.location.assign(`/${clientsAdminIndex.root}/${clientsAdminIndex.users}`);
            })
            .catch(() => window.location.reload());
    }

    isReportPage() {
        const { location } = this.props;
        const { pathname } = location;

        return ['/report', '/teamNewReport', '/playerReport', '/goalieReport', '/game-reports'].some(el =>
            pathname.includes(el)
        );
    }

    renderNavBar() {
        const {
            activeUser,
            isFavoriteListNeedToFetch,
            location,
            prospectExchangeAccount,
            isUserClient,
            isMobile,
            userHaveSomeFeatureAndPlayerId
        } = this.props;
        const { editEmailIsOpen, editableEmail, editPasswordIsOpen, editVideoPlayerIsOpen } = this.state;

        const showProfile = hasAuthKey() && (!!activeUser && !activeUser.isProcessing);
        const showBackToAdmin = hasTemporaryKey();

        const isVisibleTopSearch = isUserClient && !userHaveSomeFeatureAndPlayerId;
        const { pathname } = location || '';
        const useCenteredHeaderNav = isCenteredHeaderNavPath(pathname);

        if (prospectExchangeAccount) {
            return (
                <NavBar>
                    {!!isMobile && (
                        <ProductSelector
                            products={[]}
                            location={location}
                            prospectExchangeAccount={prospectExchangeAccount}
                        />
                    )}
                    <DeviceSelector
                        desktopLayout={
                            <LinksNav location={location} prospectExchangeAccount={prospectExchangeAccount} />
                        }
                    />
                </NavBar>
            );
        }

        return (
            <NavBar>
                <EditEmailModal
                    editEmailIsOpen={editEmailIsOpen}
                    onCancelEditEmail={this.onCancelEditEmail}
                    currentEmail={editableEmail}
                    readCurrentUser={readCurrentUser}
                />

                <EditPasswordModal isOpen={editPasswordIsOpen} onClose={this.onCancelEditPassword} />

                <EditVideoPlayerModal isOpen={editVideoPlayerIsOpen} onClose={this.onCancelEditVideoPlayer} />

                {!!showProfile && <LauncherItemsSync />}

                <HeaderStart>
                    <Link to="/">
                        <Brand>{this.renderBrand()}</Brand>
                    </Link>

                    {!!showProfile && !useCenteredHeaderNav && <AppLauncher />}

                    {!!isVisibleTopSearch && !useCenteredHeaderNav && (
                        <HeaderSearchSlot>
                            <TopSearchPanel isFavoriteListNeedToFetch={isFavoriteListNeedToFetch} />
                        </HeaderSearchSlot>
                    )}
                </HeaderStart>

                {!!useCenteredHeaderNav && !!showProfile && (
                    <HeaderCenter>
                        <DeviceSelector
                            desktopLayout={<LinksNav location={location} isMobile={isMobile} mode="all" />}
                            mobileLayout={<AppLauncher />}
                        />
                    </HeaderCenter>
                )}

                <HeaderEnd balanced={useCenteredHeaderNav}>
                    {!!showProfile && !useCenteredHeaderNav && (
                        <DeviceSelector
                            desktopLayout={<LinksNav location={location} isMobile={isMobile} mode="primary" />}
                        />
                    )}

                    <Nav align="right">
                        {!!showBackToAdmin && <BackToAdminLink onClick={this.backToAdmin} />}

                        {!!warningForUser && <InfoWarning />}

                        <ClipServiceInformer />

                        <SupportRequest />

                        {showProfile && !isUserClient ? <Language /> : null}

                        {!!showProfile && <ReleaseNote />}

                        {!!showProfile && (
                            <Profile
                                user={activeUser}
                                logout={this.logout}
                                onEditEmails={this.editEmail}
                                onEditPassword={this.editPassword}
                                onEditVideoPlayer={this.editVideoPlayer}
                            />
                        )}
                    </Nav>
                </HeaderEnd>
            </NavBar>
        );
    }

    renderBrand() {
        return <LogoComponent height={32} prospectExchangeAccount={this.props.prospectExchangeAccount} isLightLogo />;
    }

    componentDidMount() {
        const { notify } = this.props;

        const EMAIL_STATUS = localStorage.getItem('UPDATE_EMAIL');

        if (EMAIL_STATUS === 'FAIL') {
            notify(
                'Failed to update your email address. Please log in to the portal and try again to update your email address.',
                notificationTypes.ERROR
            );
            localStorage.setItem('UPDATE_EMAIL', null);
            this.logout();
        }

        if (EMAIL_STATUS === 'SUCCESS') {
            notify('Your email address has been successfully updated.', notificationTypes.SUCCESS);
            localStorage.setItem('UPDATE_EMAIL', null);
            this.logout();
        }
    }

    render() {
        const { children, prospectExchangeAccount } = this.props;
        const isReport = this.isReportPage();
        const showNavBar = !isReport;
        const showFooter = hasAuthKey() && !isReport;

        return (
            <ErrorBoundary>
                <ThemeContainer>
                    <AppLayout
                        prospectExchangeAccount={prospectExchangeAccount || isReport}
                        maxWidthContainer={prospectExchangeAccount ? MAX_WIDTH_PROSPECT : null}
                    >
                        {!!showNavBar && this.renderNavBar()}
                        {!!showNavBar && <SubNavBar />}
                        <NotificationBar />
                        <AppContent>{children}</AppContent>
                        {!prospectExchangeAccount && !!showFooter && <Footer />}
                        {!!showFooter && <TooltipAnchor />}
                        <NotificationsPanel />
                    </AppLayout>
                </ThemeContainer>
            </ErrorBoundary>
        );
    }
}

App = connect(
    mapStateToProps,
    mapDispatchToProps
)(App);

export default withRouter(App);
